import React from 'react';

const SessionConfirmationModal = ({ sessionInfo, onConfirm, onCancel }) => {
  // Format the date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  // Extract browser and OS info from user agent
  const getBrowserInfo = (userAgent) => {
    if (!userAgent) return 'Unknown device';

    let browserInfo = 'Unknown browser';

    if (userAgent.includes('Firefox')) {
      browserInfo = 'Firefox';
    } else if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
      browserInfo = 'Chrome';
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      browserInfo = 'Safari';
    } else if (userAgent.includes('Edg')) {
      browserInfo = 'Edge';
    }

    let osInfo = 'Unknown OS';

    if (userAgent.includes('Windows')) {
      osInfo = 'Windows';
    } else if (userAgent.includes('Mac')) {
      osInfo = 'Mac';
    } else if (userAgent.includes('Linux')) {
      osInfo = 'Linux';
    } else if (userAgent.includes('Android')) {
      osInfo = 'Android';
    } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
      osInfo = 'iOS';
    }

    return `${browserInfo} on ${osInfo}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Account Already Logged In</h2>
        <p className="mb-4">
          Your account is currently logged in from another device. Would you like to log out that session and continue?
        </p>

        <div className="bg-gray-100 p-4 rounded-md mb-6">
          <h3 className="font-semibold mb-2">Current Session Details:</h3>
          <ul className="text-sm">
            <li className="mb-1"><span className="font-medium">Device:</span> {getBrowserInfo(sessionInfo.user_agent)}</li>
            <li className="mb-1"><span className="font-medium">IP Address:</span> {sessionInfo.ip_address || 'Unknown'}</li>
            <li className="mb-1"><span className="font-medium">Login Time:</span> {formatDate(sessionInfo.login_time)}</li>
            <li><span className="font-medium">Last Activity:</span> {formatDate(sessionInfo.last_activity)}</li>
          </ul>
        </div>

        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Log Out Other Session
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionConfirmationModal;
